import MuiDivider, { type DividerProps } from "@mui/material/Divider";

export type { DividerProps };

export function Divider(props: DividerProps) {
  return <MuiDivider {...props} />;
}
